// src/components/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';

function Navbar() {
    return (
        <div className="navbar">
            <p>VANDR</p>
            <ul>
                <li>home</li>
                <li>blogs</li>
                <li>about</li>
                <Link to="/auth">
                    <button>Login</button>
                </Link>
            </ul>
        </div>
    );
}

export default Navbar;
